import { TFunction } from 'next-i18next'
import { Project } from 'src/core/models'
import { getProjectHeadline } from 'src/core/helpers'
import ProjectInfoCountryContent from './ProjectInfoCountryContent/ProjectInfoCountryContent'
import React from 'react'
import ProjectInfoTags from './ProjectInfoTags/ProjectInfoTags'

const EMPTY_TEXT = '-'

interface InfoSection {
  label1: string
  label2: string | React.ReactNode
  isLink?: boolean
  isVisible?: boolean
  linkLabel?: string
}

export const projectInfoSections = (
  project: Project,
  isModalPreview: boolean,
  addressLink: string,
  blockchainAdress: string,
  t: TFunction
): InfoSection[] => [

  { // Project Code
    label1: t('Projects.Fields.id'),
    label2: project?.code,
    isLink: false,
    isVisible: true
  },

  { // Headline
    label1: t('Projects.HeadLine'),
    label2: getProjectHeadline(project),
    isLink: false,
    isVisible: true
  },

  { // Company
    label1: t('Projects.Fields.Company'),
    label2: project?.billing_company_name,
    isLink: false,
    isVisible: true
  },

  { // Country
    label1: t('Projects.Fields.HostCountry'),
    label2: !project?.country ? EMPTY_TEXT : <ProjectInfoCountryContent country={project.country}/> ,
    isLink: false, isVisible: true
  },

  { // Billing Address
    label1: t('Projects.Fields.Address'),
    label2: project?.billing_address,
    isLink: false,
    isVisible: true
  },

  { // Website url
    label1: t('Projects.Fields.Website'),
    label2: project?.url,
    linkLabel: project?.url,
    isLink: true,
    isVisible: true
  },

  { // Blockchain address
    label1: t('Projects.Fields.BlockchainAddress'),
    label2: addressLink ,
    linkLabel: !project?.bc_address ? EMPTY_TEXT : blockchainAdress,
    isLink: true,
    isVisible: !isModalPreview
  },

  { // tags
    label1: t('Projects.Fields.Tags'),
    label2: <ProjectInfoTags tags={project.tags} />,
    isLink: false,
    isVisible: project.tags.length > 0
  },
]
